import {setWorkerUrl} from "/web/dist/maplibre-gl-253426af6c.mjs";
setWorkerUrl("/web/dist/maplibre-gl-worker-f4650f17aa.mjs");
export * from "/web/dist/maplibre-gl-253426af6c.mjs";
